const merchantAddress = () => ({
  "company_name": "Din Tai Fung",
  "street_address": "700 Bellevue Way NE",
  "street_address2": "#280",
  "locality": "Bellevue",
  "region": "WA",
  "country": "United States",
  "postal_code": "98004",
  "latitude": 47.617193,
  "longitude": -122.200592,
  "cross_streets": null
})

export const defaultMerchant = {
  "address": merchantAddress()
}



// WEBPACK FOOTER //
// ./client/app/util/mock_merchants.js